import { TOGGLE_SIGNATURE_MODAL_VISIBILITY, SET_SIGNATURE_MODAL_DATA } from './actionTypes'

export const toggleSignatureModalVisibility = () => {
    return {
        type : TOGGLE_SIGNATURE_MODAL_VISIBILITY
    }
}

export const setSignatureModalData = (sigPopupDetails) => {
    // console.log("ACTION :", sigPopupDetails)
    return {
        type : SET_SIGNATURE_MODAL_DATA,
        sigPopupDetails : sigPopupDetails
    }
}

